import $ from 'jquery';

const colicareModals = {
    init: function() {
        colicareModals._bindUIEvents();
    },
    _bindUIEvents: function() {
        $(document)
            .off('click', '.PCColiCareHelpLink.tooptipIcon')
            .on('click', '.PCColiCareHelpLink.tooptipIcon', function(e) {
                e.preventDefault();
                colicareModals._showColiCareHelpInfo();
            });

        $(document)
            .off('click touchstart', '.active .PCColiCareHelpLink.infoBullet')
            .on('click touchstart', '.active .PCColiCareHelpLink.infoBullet', function(e) {
                e.preventDefault();
                colicareModals._showColiCareHelpInfo();
            });
    },
    _showColiCareHelpInfo: function() {
        var url = $('#hfPCColiCareHelpUrl').val(),
            modalOptions = {
                modal: true,
                resizable: false,
                width: '550px',
                zIndex: 3000,
                title: 'What is ColiCare?'
            };

        function onSuccess(result) {
            var coliCareHelp = $('#dlgPCColiCareHelp:first').html(result);
            coliCareHelp.show();

            smartPak.ui.modal(coliCareHelp.get(0), modalOptions);
        }

        $.get(url).done(onSuccess);
    },
    _showDoseIssueModal: function(modalDiv, accountId, cancelUrl) {
        smartPak.ui.modal(modalDiv.get(0), {
            modal: true,
            resizable: false,
            width: '500px',
            title: 'ColiCare Application Issue',
            close: function() {
                modalDiv.remove();
            },
            buttons: [
                {
                    text: 'Adjust SmartPaks',
                    click: function() {
                        location.href = '/autoshipmanager/supplements/' + accountId;
                    }
                },
                {
                    text: 'Cancel ColiCare application',
                    click: function(modal) {
                        modal.close();
                        window.location.replace(cancelUrl);
                    }
                }
            ]
        });
    },
    _skipApplicationModal: function(confirmationNumber) {
        smartPak.ui.modal($('#dlgSkipApplication').get(0), {
            modal: true,
            resizable: false,
            width: '480px',
            title: 'Skip Application(s)',
            buttons: [
                {
                    text: 'No, Go Back',
                    click: function(modal) {
                        modal.close();
                    }
                },
                {
                    text: 'Yes, skip application',
                    click: function(modal) {
                        modal.close();
                        window.location.replace('/checkout/Confirmation?confirmationNumber=' + confirmationNumber);
                    }
                }
            ]
        });
    },
    _applicationSubmittedModal: function(registrationUrl, confirmationUrl) {
        smartPak.ui.modal($('#dlgApplicationSubmitted').get(0), {
            modal: true,
            resizable: false,
            width: '480px',
            title: 'Application Submitted',
            buttons: [
                {
                    text: "No, I'm finished",
                    click: function(modal) {
                        modal.close();
                        window.location.replace(confirmationUrl);
                    }
                },
                {
                    text: 'Yes, Continue',
                    click: function(modal) {
                        modal.close();
                        window.location.replace(registrationUrl);
                    }
                }
            ]
        });
    },
    _showRegistrationDenialModal: function(redirectUrl, htmlContent) {
        smartPak.ui.modal(
            $('<div id="dlgRegistrationDenied">' + htmlContent + '</div>')
                .appendTo('body')
                .get(0),
            {
                modal: true,
                resizable: false,
                width: '500px',
                title: 'Application Denied',
                close: function() {
                    window.location.replace(redirectUrl);
                },
                buttons: [
                    {
                        text: 'Continue',
                        click: function(modal) {
                            modal.close();
                            window.location.replace(redirectUrl);
                        }
                    }
                ]
            }
        );
    }
};

export default colicareModals;
